import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class ZeasnNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Zeasn...');
    return this.onlineByAjax();
  }

}

export default ZeasnNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/zeasn/NetworkStatus.js